var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_180_22295",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_180_22295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.53817 14.1666C3.2014 14.1666 2.91634 14.0499 2.68301 13.8166C2.44967 13.5833 2.33301 13.2982 2.33301 12.9614V4.03842C2.33301 3.70164 2.44967 3.41659 2.68301 3.18325C2.91634 2.94992 3.2014 2.83325 3.53817 2.83325H7.24317C7.38506 2.83325 7.5039 2.88114 7.59967 2.97692C7.69534 3.07259 7.74317 3.19136 7.74317 3.33325C7.74317 3.47514 7.69534 3.59392 7.59967 3.68959C7.5039 3.78536 7.38506 3.83325 7.24317 3.83325H3.53817C3.48684 3.83325 3.43984 3.85464 3.39717 3.89742C3.3544 3.94008 3.33301 3.98709 3.33301 4.03842V12.9614C3.33301 13.0128 3.3544 13.0598 3.39717 13.1024C3.43984 13.1452 3.48684 13.1666 3.53817 13.1666H12.4612C12.5125 13.1666 12.5595 13.1452 12.6022 13.1024C12.645 13.0598 12.6663 13.0128 12.6663 12.9614V9.25642C12.6663 9.11453 12.7142 8.9957 12.81 8.89992C12.9057 8.80425 13.0245 8.75642 13.1663 8.75642C13.3082 8.75642 13.427 8.80425 13.5227 8.89992C13.6185 8.9957 13.6663 9.11453 13.6663 9.25642V12.9614C13.6663 13.2982 13.5497 13.5833 13.3163 13.8166C13.083 14.0499 12.798 14.1666 12.4612 14.1666H3.53817ZM12.6663 4.53575L6.83051 10.3718C6.73817 10.464 6.62212 10.5112 6.48234 10.5134C6.34267 10.5155 6.22451 10.4683 6.12784 10.3718C6.03129 10.2751 5.98301 10.158 5.98301 10.0204C5.98301 9.88286 6.03129 9.76575 6.12784 9.66908L11.9638 3.83325H9.83301C9.69112 3.83325 9.57234 3.78536 9.47667 3.68959C9.3809 3.59392 9.33301 3.47514 9.33301 3.33325C9.33301 3.19136 9.3809 3.07259 9.47667 2.97692C9.57234 2.88114 9.69112 2.83325 9.83301 2.83325H13.0637C13.2356 2.83325 13.379 2.89075 13.4938 3.00575C13.6088 3.12064 13.6663 3.26403 13.6663 3.43592V6.66658C13.6663 6.80847 13.6185 6.92725 13.5227 7.02292C13.427 7.1187 13.3082 7.16658 13.1663 7.16658C13.0245 7.16658 12.9057 7.1187 12.81 7.02292C12.7142 6.92725 12.6663 6.80847 12.6663 6.66658V4.53575Z",
    fill: "#3F3273"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLinkIcon);
export default __webpack_public_path__ + "static/media/external-link-icon.c186b18de476581b898e869bd38f4d21.svg";
export { ForwardRef as ReactComponent };